module.exports = __webpack_public_path__ + "media/images/common/mymenu_bg-9070f9f5a2a4d453b6d66036bc4debf5.png";